module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-icon', [_vm._v("credit_card")]), _vm._v(" Billing information\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-ios-true",
    attrs: {
      "small": "",
      "color": "primary",
      "href": _vm.billingUrl,
      "target": "_blank"
    }
  }, [_vm._v("Make a payment")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.nextPayment) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-subheader', [_vm._v("Your next payment:")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(_vm.nextPayment.scheduled_date)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Scheduled date.")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.nextPayment.currency, _vm.nextPayment.amount)) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Invoices / Payments")]), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": "requests.transactions"
    }
  }), _vm._v(" "), (_vm.transactions && _vm.transactions.length > 0) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.transactions), function(transaction) {
    return (transaction) ? _c('v-list-tile', {
      key: transaction.id
    }, [_c('v-list-tile-action', [(transaction.result_code === "000.000.000") ? _c('v-icon', {
      attrs: {
        "color": "success"
      }
    }, [_vm._v("check")]) : _c('v-icon', {
      attrs: {
        "color": "error"
      }
    }, [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(transaction.created_date)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("#" + _vm._s(transaction.transaction_id) + ". " + _vm._s(transaction.result_description) + ".")])], 1), _vm._v(" "), (transaction.result_code === "000.000.000") ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "href": _vm.transactoinUrl(transaction.id, transaction.transaction_id),
        "target": "_blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), 1) : _c('v-card', [(!_vm.transactionRequest.loading) ? _c('v-card-text', [_vm._v("No invoices found")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      Cancel account\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      To cancel your account,\n      please email support@appointmentguru.co with the subject: \"Please cancel my account\"\n      from the email address associated with this account (" + _vm._s(_vm.me.email) + ").\n\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba82001","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Billing.vue
// module id = 1419
// module chunks = 9